// extracted by mini-css-extract-plugin
export default {"addToDirectoryLink":"OtherEdit_addToDirectoryLink__oSVLD"};